export { miningView, miningTelemetryView } from "../features/mining/state/view-mappers";
export { dashboardView, validConfirmedTierDisplay, normalizeTierDisplay, tierDisplayView } from "../features/dashboard/state/view-mappers";
import { chainLabel } from "../config/chains";
import type { WalletSessionSnapshot } from "../wallet/wallet-session";
import type { TerminalAppModel } from "./ui-types";

export function walletView(snapshot: WalletSessionSnapshot, expectedChain: number,
  signInConfiguration: TerminalAppModel["wallet"]["signInConfiguration"] = "LOADING"): TerminalAppModel["wallet"] {
  return {
    authenticated: snapshot.authenticated,
    authState: snapshot.authState,
    sessionRevision: snapshot.sessionRevision,
    signInConfiguration,
    status: snapshot.status === "CONNECTING" || snapshot.status === "SIGNING_IN" || snapshot.status === "SESSION_EXPIRED" ? snapshot.status :
      snapshot.status === "WRONG_CHAIN" ? "WRONG_NETWORK" : !snapshot.providerAvailable ? "UNAVAILABLE" :
      snapshot.connected ? "CONNECTED" : "DISCONNECTED",
    address: snapshot.account,
    chainId: snapshot.chainId,
    chainLabel: snapshot.chainId === expectedChain ? chainLabel(expectedChain) : `Chain ${snapshot.chainId ?? "—"}`,
    sessionExpiresAt: snapshot.sessionExpiresAt,
    error: snapshot.error,
  };
}
